// Libraries
import { ReactNode } from 'react';

// Styles
import styles from './StateScreen.module.css';

/**
 * @function StateScreen
 * Screen to describe the state of the app (e.g. errored or loading)
 *
 * @example
 * return (
 *   <StateScreen title='' />
 * )
 */
function StateScreen({
    title,
    icon = <></>,
    children = <></>,
}: StateScreenProps): JSX.Element {
    return (
        <div className={styles.container}>
            <div className={styles.icon}>{icon}</div>
            <h1 className={styles.header}>{title}</h1>
            {children}
        </div>
    );
}

/**
 * @interface StateScreenProps
 * Describes the properties required for the StateScreen component
 *
 * @property {string} title
 * @property {ReactNode} children
 */
export interface StateScreenProps {
    title: string;
    icon?: ReactNode;
    children?: ReactNode;
}

// Exports
export default StateScreen;
